import styled from "styled-components"
import CustomBlockButton from "../../../../../components/button/CustomBlockButton"

// 헤더 스타일 수정
export const HeaderWrapper = styled.div`
    padding: 16px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 12;
    border-bottom: 1px solid #e0e0e0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`

// RackConditionInfo 스타일 수정
export const RackConditionInfo = {
  Container: styled.div`
        padding: 16px;
        margin-top: 10px;
        background: #f9f9f9;
        border-radius: 8px;
        margin: 16px;
    `,
  InfoItems: styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
  InfoItem: styled.div`
        width: auto;

        .label {
            font-weight: 600;
            margin-bottom: 8px;
            font-size: 14px;
            color: #222;
        }

        button {
            border: 1px solid #e0e0e0;
            background: #f5f5f5;
            border-radius: 6px;
            padding: 10px 16px;
            font-weight: 500;
            transition: all 0.2s;
            color: #333;
            
            &:hover {
                background: #e8e8e8;
                transform: translateY(-1px);
            }
            
            &:active {
                transform: translateY(0);
            }

            &.selected {
                &:first-child {
                    border: 1px solid #15803d;
                    background: #16a34a;
                    color: #fff;
                    
                    &:hover {
                        background: #15803d;
                    }
                }
                
                &:last-child {
                    border: 1px solid #1d4ed8;
                    background: #2563eb;
                    color: #fff;
                    
                    &:hover {
                        background: #1d4ed8;
                    }
                }
                
                &:not(:first-child):not(:last-child) {
                    border: 1px solid #1d4ed8;
                    background: #2563eb;
                    color: #fff;
                    
                    &:hover {
                        background: #1d4ed8;
                    }
                }
            }

            &.delete {
                background: #fee2e2;
                color: #b91c1c;
                border: 1px solid #fecaca;
                
                &:hover {
                    background: #fecaca;
                    border-color: #ef4444;
                }
            }
        }

        .input-box {
            flex: 1;
            
            input {
                border-radius: 6px;
                border: 1px solid #e0e0e0;
                transition: all 0.2s;
                
                &:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
                }
            }
        }
        
        .flex {
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }
    `,
}

// 상단 설정(타입/링크/규격)을 한 줄로 축소한 컴팩트 바
export const CompactInfo = {
  Bar: styled.div`
        margin: 12px 16px 0;
        padding: 10px 12px;
        background: #f9f9f9;
        border-radius: 8px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px 18px;
    `,
  Field: styled.div`
        display: flex;
        align-items: center;
        gap: 8px;

        .label {
            font-size: 12px;
            font-weight: 700;
            color: #64748b;
            white-space: nowrap;
        }
    `,
  Toggle: styled.div`
        display: flex;
        gap: 4px;

        button {
            height: 30px;
            padding: 0 10px;
            font-size: 12px;
            font-weight: 600;
            border: 1px solid #e0e0e0;
            background: #fff;
            border-radius: 6px;
            color: #475569;
            cursor: pointer;

            &.selected.normal {
                background: #16a34a;
                border-color: #15803d;
                color: #fff;
            }
            &.selected.inventory {
                background: #2563eb;
                border-color: #1d4ed8;
                color: #fff;
            }
        }
    `,
  LinkButton: styled.button`
        height: 30px;
        max-width: 200px;
        padding: 0 10px;
        font-size: 12px;
        font-weight: 600;
        border: 1px solid #e0e0e0;
        background: #fff;
        border-radius: 6px;
        color: #475569;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.selected {
            border-color: #ec4899;
            color: #db2777;
            background: #fdf2f8;
        }
    `,
  SizeInputs: styled.div`
        display: flex;
        gap: 6px;

        input {
            width: 60px;
            height: 30px;
            padding: 0 8px;
            border: 1px solid #e0e0e0;
            border-radius: 6px;
            font-size: 12px;
            text-align: center;
            background: #fff;

            &:focus {
                outline: none;
                border-color: #2563eb;
                box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
            }
        }
    `,
}

// 로케이션 삭제 (맨 아래 위험영역, 약하게 강조)
export const DangerZone = styled.div`
    margin: 18px 16px 6px;
    padding-top: 12px;
    border-top: 1px dashed #e2e8f0;
    display: flex;
    justify-content: flex-end;

    button {
        height: 34px;
        padding: 0 14px;
        font-size: 12px;
        font-weight: 600;
        color: #b91c1c;
        background: transparent;
        border: 1px solid #fecaca;
        border-radius: 6px;
        cursor: pointer;

        &:hover {
            background: #fef2f2;
            border-color: #ef4444;
        }
    }
`

// LineBreaker 스타일 수정
export const LineBreaker = styled.div`
    background-color: #e0e0e0;
    height: 1px;
    margin: 16px;
`

// GenerateItem 스타일 수정
export const GenerateItem = {
  Container: styled.div`
        padding: 16px;
        margin: 0 16px;
        background: #f9f9f9;
        border-radius: 8px;
    `,
  Label: styled.div`
        font-weight: 600;
        margin-bottom: 12px;
        font-size: 14px;
        color: #222;
    `,
  Tabs: styled.div`
        display: flex;
        gap: 6px;
        margin-bottom: 12px;

        button {
            flex: 1;
            height: 40px;
            border: 1px solid #e0e0e0;
            background: #fff;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 600;
            color: #64748b;
            cursor: pointer;
            transition: all 0.15s;

            &.active {
                border-color: #2563eb;
                background: #eff4ff;
                color: #2563eb;
            }
        }
    `,
  TabPanel: styled.div`
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .hint {
            font-size: 12px;
            color: #64748b;
            margin-bottom: 10px;
        }
    `,
  Textarea: styled.textarea`
        height: 150px;
        width: 100%;
        padding: 12px;
        border-radius: 6px;
        outline: none;
        border: 1px solid #e0e0e0;
        display: block;
        font-size: 14px;
        transition: all 0.2s;
        resize: vertical;
        font-family: inherit;
        background: #fff;
        
        &:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
        }
    `,
  AddButton: styled(CustomBlockButton)`
        border: none;
        background: #2563eb;
        color: white;
        width: auto;
        padding: 10px 20px;
        margin-top: 12px;
        border-radius: 6px;
        font-weight: 500;
        transition: all 0.2s;

        &:hover {
            background: #1d4ed8;
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    `,
  ButtonRow: styled.div`
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        align-items: center;
    `,
  PickButton: styled(CustomBlockButton)`
        border: 1px solid #2563eb;
        background: #eff4ff;
        color: #2563eb;
        width: auto;
        padding: 10px 20px;
        margin-top: 12px;
        border-radius: 6px;
        font-weight: 600;
        transition: all 0.2s;

        &:hover {
            background: #dbe6ff;
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    `,
}

// Items 스타일 수정
export const Items = {
  Container: styled.div`
        padding: 0 16px;
    `,
  TableWrapper: styled.div`
        position: relative;
        overflow: auto;
        width: 100%;
        /* 상품 영역 강조: 화면 비례로 더 크게 */
        height: 48vh;
        min-height: 300px;
        border-radius: 8px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        border: 1px solid #e0e0e0;

        table {
            table-layout: fixed;
            width: 100%;
            border-spacing: 0;
            text-align: center;
            font-size: 13px;

            & > thead {
                position: sticky;
                top: 0;
                background: #f0f0f0;
                z-index: 10;
            }

            & > thead > tr > th {
                text-align: left;
                color: #222;
                font-weight: 600;
                padding: 12px 10px;
                font-size: 13px;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                border-bottom: 1px solid #e0e0e0;
            }

            & tr {
                transition: background-color 0.2s;
                &:hover {
                    background-color: #f5f5f5;
                }
            }

            & > tbody > tr > td {
                padding: 10px 8px;
                border-bottom: 1px solid #e0e0e0;
                color: #333;
                font-size: 13px;
            }

            & > tbody > tr > td > input {
                width: 100%;
                height: 38px;
                padding: 8px 12px;
                border: 1px solid #e0e0e0;
                background: #fff;
                font-weight: 500;
                border-radius: 6px;
                outline: none;
                transition: all 0.2s;

                &:hover {
                    background: #f9f9f9;
                }
                
                &:focus {
                    border: 1px solid #2563eb;
                    background: #fff;
                    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
                }
            }

            & > tbody > tr > td > .quantityCell {
                width: 100%;
                height: 38px;
                padding: 8px 12px;
                border: 1px solid #e0e0e0;
                background: #fff;
                font-weight: 700;
                font-size: 14px;
                color: #1a202c;
                border-radius: 6px;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s;

                &:hover {
                    background: #f9f9f9;
                    border-color: #2563eb;
                }

                &:active {
                    background: #eff4ff;
                }
            }

            & .deleteButton {
                color: #fff;
                border: none;
                background: #ef4444;
                font-size: 13px;
                height: 38px;
                max-width: 60px;
                border-radius: 6px;
                transition: all 0.2s;
                
                &:hover {
                    background: #dc2626;
                    transform: translateY(-1px);
                }
                
                &:active {
                    transform: translateY(0);
                }
            }

            & .copyButton {
                color: #333;
                border: 1px solid #e0e0e0;
                background: #f5f5f5;
                font-size: 13px;
                height: 38px;
                max-width: 60px;
                border-radius: 6px;
                transition: all 0.2s;

                &:hover {
                    background: #e8e8e8;
                    transform: translateY(-1px);
                }

                &:active {
                    transform: translateY(0);
                }
            }

            & .quickFillButton {
                color: #2563eb;
                border: 1px solid #2563eb;
                background: #eff4ff;
                font-size: 12px;
                font-weight: 600;
                height: 38px;
                max-width: 70px;
                border-radius: 6px;
                transition: all 0.2s;

                &:hover {
                    background: #dbe6ff;
                    transform: translateY(-1px);
                }

                &:active {
                    transform: translateY(0);
                }
            }

            & .unitButton {
                color: #333;
                border: 1px solid #e0e0e0;
                background: #f5f5f5;
                font-size: 13px;
                height: 38px;
                max-width: 60px;
                border-radius: 6px;
                transition: all 0.2s;
                
                &:hover {
                    background: #e8e8e8;
                    transform: translateY(-1px);
                }
                
                &:active {
                    transform: translateY(0);
                }
            }
        }
    `,
}

// Notice 스타일 수정
export const Notice = {
  Container: styled.div`
        padding: 16px;
        margin: 0 16px;
        background: #fffbeb;
        border-radius: 8px;
        border: 1px solid #fef3c7;
        margin-top: 16px;

        .notice {
            font-size: 14px;
            line-height: 1.5;
            color: #92400e;

            span {
                font-weight: 700;
                color: #78350f;

                &.red {
                    color: #b91c1c;
                }
            }
        }
    `,
}

// Footer 스타일 수정
export const Footer = {
  Container: styled.div`
        position: sticky;
        bottom: 0;
        padding: 16px;
        z-index: 12;
        background: white;
        border-top: 1px solid #e0e0e0;
        display: flex;
        justify-content: flex-end;

        button {
            width: auto;
            padding: 10px 24px;
            background: #2563eb;
            border: none;
            color: #fff;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.2s;
            
            &:hover {
                background: #1d4ed8;
                transform: translateY(-1px);
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }
            
            &:active {
                transform: translateY(0);
                box-shadow: none;
            }
        }
    `,
}

// LinkToLocationModal 스타일 수정
export const LinkToLocationModal = {
  Container: styled.div`
        .headerWrapper {
            padding: 16px;
            border-bottom: 1px solid #e0e0e0;
        }

        .bodyWrapper {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 16px;
            max-height: 400px;
            overflow-y: auto;
            
            button {
                text-align: left;
                background: #f5f5f5;
                border: 1px solid #e0e0e0;
                border-radius: 6px;
                padding: 20px 16px;
                transition: all 0.2s;
                color: #333;
                
                &:hover {
                    background: #e8e8e8;
                    border-color: #d0d0d0;
                    transform: translateY(-1px);
                }
                
                &:active {
                    transform: translateY(0);
                }
                
                &:first-child {
                    background: #dbeafe;
                    border-color: #bfdbfe;
                    color: #1e40af;
                    font-weight: 500;
                    
                    &:hover {
                        background: #bfdbfe;
                    }
                }
            }
        }
    `,
}

// DeleteModal 스타일 수정
export const DeleteModal = {
  Container: styled.div`
        
    `,
  HeaderWrapper: styled.div`
        padding: 16px;
        border-bottom: 1px solid #e0e0e0;
    `,
  BodyWrapper: styled.div`
        padding: 24px 16px;

        .notice {
            font-weight: 600;
            font-size: 16px;
            color: #222;
            text-align: center;
            margin-bottom: 24px;
        }

        .buttons {
            display: flex;
            gap: 12px;
            justify-content: center;

            button {
                width: 120px;
                padding: 10px 0;
                border-radius: 6px;
                font-weight: 500;
                transition: all 0.2s;
                
                &:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                }
                
                &:active {
                    transform: translateY(0);
                    box-shadow: none;
                }
                
                &.delete {
                    background: #ef4444;
                    color: #fff;
                    border: none;
                    
                    &:hover {
                        background: #dc2626;
                    }
                }

                &.cancel {
                    background: #f5f5f5;
                    color: #333;
                    border: 1px solid #e0e0e0;
                    
                    &:hover {
                        background: #e8e8e8;
                    }
                }
            }
        }
    `,
}
